// extracted by mini-css-extract-plugin
module.exports = {"item":"Breadcrumb-module__item___1Ni8p","detail":"Breadcrumb-module__detail___1tnJV","breadcrumb":"Breadcrumb-module__breadcrumb___3gGOi","pc":"Breadcrumb-module__pc___4KkeL"};